import { useOfflineQueue } from '../hooks/useOfflineQueue';

export default function OfflineQueueBanner() {
  const { pendingCount, isOnline } = useOfflineQueue();

  if (isOnline && pendingCount === 0) return null;

  return (
    <div className={`sw-banner ${isOnline ? 'sw-banner--sync' : 'sw-banner--update'}`}>
      {isOnline
        ? `${pendingCount} offline sale${pendingCount > 1 ? 's' : ''} pending sync`
        : `Offline mode — sales will be queued and synced when connected (${pendingCount} pending)`}
    </div>
  );
}
